import { dividerClasses as muiDividerClasses } from '@mui/material';
export * from './Divider';
export const dividerClasses = muiDividerClasses;
